var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "mb5" },
        [
          _c(
            "el-form",
            {
              ref: "queryForm",
              staticClass: "queryFormClass",
              attrs: {
                model: _vm.queryForm,
                "label-position": "top",
                size: "small",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("basicData.CustomerName"),
                            prop: "customerAlias",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("orderDetails.pleaseInput"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryForm.params.customerAlias,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryForm.params,
                                  "customerAlias",
                                  $$v
                                )
                              },
                              expression: "queryForm.params.customerAlias",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("basicData.CustomerCode"),
                            prop: "id",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("orderDetails.pleaseInput"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryForm.params.id,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm.params, "id", $$v)
                              },
                              expression: "queryForm.params.id",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("basicData.AccountName"),
                            prop: "username",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("orderDetails.pleaseInput"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryForm.params.username,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm.params, "username", $$v)
                              },
                              expression: "queryForm.params.username",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 8 } }, [
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          icon: "el-icon-search",
                          size: "small",
                        },
                        on: { click: _vm.getDataSearch },
                      },
                      [_vm._v(_vm._s(_vm.$t("basicData.Search")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-refresh", size: "small" },
                        on: { click: _vm.queryFormReset },
                      },
                      [_vm._v(_vm._s(_vm.$t("basicData.reset")) + " ")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "div",
            { staticClass: "mb10", staticStyle: { float: "right" } },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value:
                        "but:finance:basicData:accountManagement:ExportAccountInformation",
                      expression:
                        "'but:finance:basicData:accountManagement:ExportAccountInformation'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.exportAccount(1)
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("basicData.ExportAccountInformation")) + " "
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value:
                        "but:finance:basicData:accountManagement:ExportAccountRollover",
                      expression:
                        "'but:finance:basicData:accountManagement:ExportAccountRollover'",
                      arg: "remove",
                    },
                  ],
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.exportAccount(2)
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("basicData.ExportAccountRollover")) + " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              ref: "elTable",
              staticClass: "table-height",
              attrs: {
                data: _vm.tableData,
                border: "",
                height: _vm.tableHeightRow.height,
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55", align: "center" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("basicData.serialNumber"),
                  width: "60px",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              (_vm.queryForm.pageNumber - 1) *
                                _vm.queryForm.pageSize +
                                scope.$index +
                                1
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "customerAlias",
                  label: _vm.$t("basicData.CustomerName"),
                  align: "left",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "top-end",
                              "popper-class": "copy",
                              trigger: "hover",
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.copy(scope.row.customerAlias)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("orderDetails.copy")))]
                            ),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#00A551",
                                  cursor: "pointer",
                                },
                                attrs: { slot: "reference" },
                                on: {
                                  click: function ($event) {
                                    return _vm.accountDetails(scope.row)
                                  },
                                },
                                slot: "reference",
                              },
                              [_vm._v(_vm._s(scope.row.customerAlias))]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "id",
                  label: _vm.$t("basicData.CustomerCode"),
                  align: "left",
                  "min-width": "160",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "username",
                  label: _vm.$t("basicData.AccountName"),
                  align: "left",
                  "min-width": "160",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "balance",
                  label: _vm.$t("basicData.AccountBalance"),
                  align: "center",
                  "min-width": "160",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "initialCreditLimit",
                  label: _vm.$t("basicData.creditLimit"),
                  align: "center",
                  "min-width": "140",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "unsettledAmount",
                  label: _vm.$t("basicData.AccumulatedUnsettled"),
                  align: "center",
                  "min-width": "140",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [_vm._v(_vm._s(scope.row.unsettledAmount))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "totalBalance",
                  label: _vm.$t("basicData.TotalBalance"),
                  align: "center",
                  "min-width": "140",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "paymentCycle",
                  label: _vm.$t("basicData.billingPeriod"),
                  align: "center",
                  "min-width": "140",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("basicData.operate"),
                  align: "left",
                  width: "160",
                  fixed: "right",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "permit",
                                    rawName: "v-permit:remove",
                                    value:
                                      "but:finance:basicData:accountManagement:setUpABillingPeriod",
                                    expression:
                                      "'but:finance:basicData:accountManagement:setUpABillingPeriod'",
                                    arg: "remove",
                                  },
                                ],
                                attrs: { size: "mini", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.setUpABillingPeriod(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("basicData.SetUpABillingPeriod")
                                  ) + " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.queryForm.pageNumber,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.queryForm.pageSize,
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "current-change": _vm.getData,
                  "size-change": _vm.getData,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("basicData.SetUpABillingPeriod"),
            visible: _vm.showCollectionCycle,
            width: "60%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCollectionCycle = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  key: _vm.showCollectionCycle,
                  ref: "paymentCycle",
                  attrs: {
                    model: _vm.collectionCycleData,
                    rules: _vm.rules,
                    "label-width": "auto",
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c(
                          "div",
                          { staticClass: "grid-content bg-purple" },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label:
                                    _vm.$t("basicData.CustomerName") + "：",
                                  prop: "customerAlias",
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.collectionCycleData.customerAlias
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c(
                          "div",
                          { staticClass: "grid-content bg-purple" },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label:
                                    _vm.$t("basicData.CurrentBillingPeriod") +
                                    "：",
                                  prop: "paymentCycle",
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.collectionCycleData.paymentCycle)
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c(
                          "div",
                          { staticClass: "grid-content bg-purple" },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label:
                                    _vm.$t("basicData.AdjustTheBillingPeriod") +
                                    "：",
                                  prop: "days",
                                },
                              },
                              [
                                _c("el-input", {
                                  model: {
                                    value: _vm.collectionCycleData.days,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.collectionCycleData,
                                        "days",
                                        $$v
                                      )
                                    },
                                    expression: "collectionCycleData.days",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showCollectionCycle = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("basicData.Cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveCollectionCycle()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("basicData.determine")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.$t("basicData.AccountDetails"),
            "append-to-body": true,
            visible: _vm.showAccountDetail,
            direction: "ltr",
            size: "90%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showAccountDetail = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("account-details", {
                key: _vm.detailKey,
                attrs: { "query-form": _vm.rowDetail },
                on: { closeDetail: _vm.closeDetail },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("basicData.SelectTheExportTime") + "：",
            visible: _vm.showExportTime,
            width: "600px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showExportTime = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "exportTime",
                  attrs: {
                    model: _vm.exportTimeForm,
                    "label-width": "auto",
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("basicData.SelectTheExportTime"),
                        prop: "exportTime",
                        rules: {
                          required: true,
                          message: _vm.$t("basicData.CannotBeEmpty"),
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetimerange",
                          "range-separator": _vm.$t("operationCenter.to"),
                          "start-placeholder": _vm.$t(
                            "operationCenter.startDate"
                          ),
                          "end-placeholder": _vm.$t("operationCenter.endDate"),
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.exportTimeForm.exportTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.exportTimeForm, "exportTime", $$v)
                          },
                          expression: "exportTimeForm.exportTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showExportTime = false
                      _vm.exportTimeForm.exportTime = []
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("basicData.Cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.exportAccountFlow()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("basicData.determine")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }